import { useState } from 'react';

import { PostChooseQuoteItems } from 'services/shoppingCart/postChooseQuoteItems';
import { ParamsDataProductCart, ParamsProduct, ParamsBodyCartState, ParamsDataChooseQuoteItems, ParamsBodyParseProductCart } from 'utils/typeServices';

const defaultCart = {
    customerId: 0,
    cD_PEDIDO: 0,
    cD_COTACAO: 0,
    productPlan: {
        cD_COTACAO_ITEM: 0,
        cD_PRODUTO: 0,
        nR_TIPO_PRODUTO: 0,
        nR_PORCENTAGEM_INDENIZACAO: 0,
        nM_PRODUTO: '',
        vL_TOTAL: ''
    },
    productAdd: [],
    vL_TOTAL_Cart: ''
}

const useShoppingCart = () => {
    const [dataProductCart, setDataProductCart] = useState<ParamsDataProductCart>(JSON.parse(JSON.stringify(defaultCart)));
    const [dataChooseQuoteItems, setDataChooseQuoteItems] = useState<ParamsDataChooseQuoteItems>();

    const handleClearShoppingCart = () => {
        setDataProductCart(JSON.parse(JSON.stringify(defaultCart)));
        setDataChooseQuoteItems(undefined);
    };

    const handleParseProductCart = ({ body }: { body: ParamsBodyParseProductCart }) => {
        let productAdd: Array<ParamsProduct> = [];

        const productPlanAux = body.quoteItemsChooses.find(({ nR_TIPO_PRODUTO }) => nR_TIPO_PRODUTO === 11 || nR_TIPO_PRODUTO === 12);
        body.quoteItemsChooses.map(({ cD_COTACAO_ITEM, cD_PRODUTO, nR_TIPO_PRODUTO, nR_PORCENTAGEM_INDENIZACAO, dS_TITULO_SITE, vL_TOTAL, dS_PRODUTO }) => nR_TIPO_PRODUTO === 13 && productAdd.push({ cD_COTACAO_ITEM, cD_PRODUTO, nR_TIPO_PRODUTO, nR_PORCENTAGEM_INDENIZACAO, nM_PRODUTO: dS_TITULO_SITE, vL_TOTAL, dS_PRODUTO }));

        let totalAux = 0;

        body.quoteItemsChooses.map(({ vL_TOTAL }) => totalAux = totalAux + parseFloat(vL_TOTAL.split(' ')[1].replace('.', '').replace(',', '.')));

        if (productPlanAux && productAdd) {
            setDataProductCart({
                ...dataProductCart,
                customerId: body.customerId,
                cD_PEDIDO: body.cD_PEDIDO,
                cD_COTACAO: body.cD_COTACAO,
                productPlan: {
                    cD_COTACAO_ITEM: productPlanAux?.cD_COTACAO_ITEM,
                    cD_PRODUTO: productPlanAux?.cD_PRODUTO,
                    nR_TIPO_PRODUTO: productPlanAux?.nR_TIPO_PRODUTO,
                    nR_PORCENTAGEM_INDENIZACAO: productPlanAux?.nR_PORCENTAGEM_INDENIZACAO,
                    nM_PRODUTO: productPlanAux?.dS_TITULO_SITE,
                    vL_TOTAL: productPlanAux?.vL_TOTAL,
                    dS_PRODUTO: productPlanAux?.vL_TOTAL
                },
                productAdd: productAdd,
                vL_TOTAL_Cart: `${totalAux.toFixed(2)}`.replace('.', ',')
            });
        }
    }

    const handleProductCart = ({ bodyBase, body, addProduct, productPlan }: { bodyBase: ParamsBodyCartState, body: ParamsProduct, addProduct: boolean, productPlan: boolean }) => {
        let cartAux = dataProductCart;

        if (productPlan) {
            cartAux.productPlan = body;
        } else {
            if (addProduct) {
                if (body.nM_PRODUTO?.includes("Pacote")) {
                    cartAux.productAdd = dataProductCart?.productAdd?.filter(({ nM_PRODUTO }) => !nM_PRODUTO?.includes("Pacote"));
                }

                cartAux.productAdd.push(body);
            } else {
                cartAux.productAdd = dataProductCart.productAdd.filter(({ cD_PRODUTO }) => cD_PRODUTO !== body.cD_PRODUTO);
            }
        }
        let totalAux = parseFloat(cartAux.productPlan.vL_TOTAL.split(' ')[1].replace('.', '').replace(',', '.'));

        cartAux.productAdd.map(({ vL_TOTAL }) => totalAux = totalAux + parseFloat(vL_TOTAL.split(' ')[1].replace(',', '.')));
        cartAux.vL_TOTAL_Cart = `${totalAux.toFixed(2)}`.replace('.', ',');

        if (productPlan) {
            setDataProductCart({
                ...dataProductCart,
                customerId: bodyBase.customerId,
                cD_PEDIDO: bodyBase.cD_PEDIDO,
                cD_COTACAO: bodyBase.cD_COTACAO,
                productPlan: cartAux.productPlan,
                productAdd: cartAux.productAdd,
                vL_TOTAL_Cart: cartAux.vL_TOTAL_Cart
            });
        } else {
            setDataProductCart({
                ...dataProductCart,
                productPlan: cartAux.productPlan,
                productAdd: cartAux.productAdd,
                vL_TOTAL_Cart: cartAux.vL_TOTAL_Cart
            });
        }
    }

    const handlePostChooseQuoteItems = async () => {
        let listProductAux = dataProductCart.productAdd.map(({ cD_COTACAO_ITEM, cD_PRODUTO, nR_TIPO_PRODUTO }) => {
            return { cD_COTACAO_ITEM, cD_PRODUTO, nR_TIPO_PRODUTO }
        });

        listProductAux.push({
            cD_COTACAO_ITEM: dataProductCart.productPlan.cD_COTACAO_ITEM,
            cD_PRODUTO: dataProductCart.productPlan.cD_PRODUTO,
            nR_TIPO_PRODUTO: dataProductCart.productPlan.nR_TIPO_PRODUTO
        });

        const data = await PostChooseQuoteItems({
            body: {
                cD_COTACAO: dataProductCart.cD_COTACAO,
                customerId: dataProductCart.customerId,
                cD_PEDIDO: dataProductCart.cD_PEDIDO,
                quoteItemsChoose: listProductAux
            }
        });

        if (data?.data) {
            setDataChooseQuoteItems(data.data);
        }
    }


    return { dataProductCart, dataChooseQuoteItems, handleProductCart, handlePostChooseQuoteItems, handleClearShoppingCart, handleParseProductCart };
}

export default useShoppingCart;